// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)
